import React from "react";
import { motion } from "framer-motion";

/**
 * Masked line-by-line text reveal.
 * Pass an array of strings (each string = one line).
 */
export default function MaskedReveal({
  lines = [],
  as: Tag = "h1",
  className = "",
  delay = 0,
  stagger = 0.1,
}) {
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span
          key={i}
          className="reveal-mask block"
          style={{
            display: "block",
            overflow: "hidden",
            paddingBottom: "0.15em",
            paddingTop: "0.02em",
            lineHeight: 1.05,
          }}
        >
          <motion.span
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 1.1,
              ease: [0.16, 1, 0.3, 1],
              delay: delay + i * stagger,
            }}
            style={{ display: "block", willChange: "transform" }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}
